import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from 'shared/lib/classNames/classNames';
import cls from './Title.module.scss';
export var Title = function (props) {
    var _a;
    var className = props.className, positionCenter = props.positionCenter, children = props.children;
    return (_jsx("h2", { className: classNames(cls.Title, (_a = {}, _a[cls.positionCenter] = positionCenter, _a), [className]), children: children }));
};
